<template>
    <div class="basicConfig chartConfig_viewDP">
        <div class="chartDivConfig numViewConfig numViewConfig_unit minInput">
            <span class="span_til">X</span>
            <el-input v-model="config.trans.x" type="number" min="0"
                      :max="(pageSize.width-config.trans.width)" @change="getChange('x')"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit minInput">
            <span class="span_til">Y</span>
            <el-input v-model="config.trans.y" type="number" min="0"
                      :max="(pageSize.height-config.trans.height)" @change="getChange('y')"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit minInput">
            <span class="span_til">宽</span>
            <el-input v-model="config.trans.width" type="number" :min="config.trans.minWidth"
                      @change="getChange('w')"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit minInput">
            <span class="span_til">高</span>
            <el-input v-model="config.trans.height" type="number" :min="config.trans.minHeight"
                      @change="getChange('h')"></el-input>
            <div class="unit">px</div>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/5/19 1:47 下午
     */
    export default {
        name: 'basicConfig',
        components: {},
        props: {},
        computed: {
            config() {
                let index = null;
                this.$store.state.designer.chartList.map((item, i) => {
                    if (item.id === this.$store.state.designer.chart.id) {
                        index = i;
                    }
                });
                if (index !== null) {
                    return this.$store.state.designer.chartList[index];
                } else {
                    return {
                        trans: {
                            x: 0,
                            y: 0,
                            width: 0,
                            minWidth: 0,
                            height: 0,
                            minHeight: 0,
                        }
                    }
                }
            },
            nowChart() {
                return this.$store.state.designer.nowChart;
            },
            pageSize() {
                return this.$store.state.designer.pageSize;
            },
        },
        data() {
            return {}
        },
        methods: {
            getResizeChart() {
                if (this.config.class === 'chart') {
                    let dom = document.getElementById('screen_dom_' + this.config.id);
                    let echart = echarts.init(dom);
                    echart.resize();
                }
            },
            //操作设置
            getChange(type) {
                if (type === 'x') {
                    // if (this.config.trans.x < 0) {
                    //     this.config.trans.x = 0;
                    // } else if (this.config.trans.x > 0) {
                    //     if (this.config.trans.x > (this.nowChart.comParam.page.width - this.config.trans.width)) {
                    //         this.config.trans.x = (this.nowChart.comParam.page.width - this.config.trans.width);
                    //     }
                    // }
                } else if (type === 'y') {
                    // if (this.config.trans.y < 0) {
                    //     this.config.trans.y = 0;
                    // } else if (this.config.trans.y > 0) {
                    //     if (this.config.trans.y <= (this.nowChart.comParam.page.height - this.config.trans.height)) {
                    //         this.config.trans.y = (this.nowChart.comParam.page.height - this.config.trans.height);
                    //     }
                    // }
                } else if (type === 'w') {
                    this.getResizeChart();
                } else if (type === 'h') {
                    this.getResizeChart();
                }
            },
        },
        mounted() {

        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .basicConfig {
        .minInput {
            > span {
                max-width: 30px !important;
            }

            .el-input {
                width: 50% !important;
            }
        }
    }
</style>